import {Component, OnInit} from '@angular/core';
import {Chunker} from '../framework/chunker';
import {AppUser} from '../framework/AppUser';
import {DashboardResponse, QARService} from '../services/qar.service';

@Component({
	selector: 'app-page-home',
	templateUrl: 'home.html',
	providers: [AppUser, QARService]
})
export class PageHomeComponent implements OnInit {
	public constructor(public appUser: AppUser, public api: QARService) {
	}

	public dashboard = {
		data: new DashboardResponse(),
		descriptions: {
			UnsolvedAnomalyCount: 'Anomalies To Solve',
			UnsolvedAnomalyCountInActiveSystem: 'Anomalies To Solve (inactive)',
			RolesToMapCount: 'Unmapped Roles',
			// number of SOD clashes
			SODClashesCount: 'Live SOD clashes (pending only)',
			//  how many to chase
			QARReportsToChase: 'QAR reports to chase',
			// how many approval requests to chase
			ApprovalRequestsToChase: 'Approvals to chase',
			// errors in audit log in the past 2 - 3 days
			AuditLogErrors: 'Audit Log Errors (last 3 days)',
			ExceptionLogs: 'Server Logs',
			InactiveUsers: 'Users Inactive',
			InactiveManagers: 'Managers Inactive',
			ReportsPendingCounterSigning: 'Reports Pending Counter Signing',
			ApprovalRequestsPendingCounterSigning: 'Approval Requests Pending Counter Signing',
			RejectedQuarterlyStatus: 'User Rejection'

		},
		serverLogsDescriptions: {
			SETTINGS: 'Settings',
			EMAILER: 'Emailer',
			AUTHENTICATION: 'Authentication',
			ACTIVE_DIRECTORY: 'Active Directory',
			APP_QAR: 'QAR'
		},
		rejectedQuarterlyStatusDes: {
			TotalCount: 'Total Rejected Count',
			null: 'To Verify',
			ticket_to_be_created: 'Ticket to be created',
			ticket_created: 'Ticket created',
			ticket_in_progress: 'Ticket in progress',
			ticket_closed: 'Ticket closed',
			done_verified: 'Done & Verified'
		}
	};

	public loaderLogData;

	public canSeeDashboard = false;
	public canSeeLogLoaders = false;
	public loading = false;
	public loadingLog = false;

	ngOnInit() {
		this.canSeeDashboard = this.appUser.isAllowed('ACCESS_DASHBOARD');
		if (this.canSeeDashboard) {
			this.loading = true;
			this.api.retrieveDashboard().then(r => {
				this.loading = false;
				this.dashboard.data = r;
			}, e => {
				alert('Sorry, could not retrieve dashboard');
			});
		}
	}

	public checkLoaderLog() {
		this.loadingLog = true;
		this.api.retrieveLoadersLog().then(r => {
			this.loadingLog = false;
			this.loaderLogData = r;
		}, e => {
			alert('Sorry, could not retrieve log data');
		});
	}
}
